export const MAX_IMAGES = 12;
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB — must match firebase/storage.rules
export const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
